import usePermissionStore from './modules/permission'
import useUserStore from './modules/user'

const useStore = () => ({
  user: useUserStore(),
  permission: usePermissionStore(),
})

export default useStore
